import { Container, ContainerItem } from '../common/container/Container'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'
import { GENE_TYPE_API_KEY, GENE_TYPE_SERVICE_KEY } from '../modules/gene-types'
import { GeneTypeProps, GENE_TYPES_MODULE } from '../modules/gene-types/container'
import { GeneTypeService } from '../modules/gene-types/services/GeneTypeService'
import { GeneTypeApi } from '../modules/gene-types/api/GeneTypeApi'

let container: Container

function init(p: GeneTypeProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(GENE_TYPE_API_KEY, new ContainerItem({ instance: new GeneTypeApi() }))
  items.set(
    GENE_TYPE_SERVICE_KEY,
    new ContainerItem({
      instance: new GeneTypeService({ apiKey: GENE_TYPE_API_KEY }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getGeneTypeContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[GENE_TYPES_MODULE],
      },
    })
  }

  return container
}
